export default {
  name: '3DOcean',
  abbreviation: '3D',
  domain: '3docean.net',
  google_analytics_id: 'UA-11834194-2',
  google_remarketing_label: '24jqCK2CugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. low poly building',
  filters: {
    aggregations: {
      poly_count: {
        min: 4000,
        max: 10000,
        avg: 5000
      }
    }
  },
  assets_domains: {
    item_thumbnail: 'thumb-3do.s3.envato.com',
    item_image: 'image-3do.s3.envato.com'
  },
  features: {
    /**
     * @description Enable automatic sign-in for 3DOcean
     * @author Foundation
     * @expires
     */
    'enable-auto-signin': true
  }
}
